import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-account-removed-dialog',
  templateUrl: './account-removed-dialog.component.html',
  styleUrls: ['./account-removed-dialog.component.scss']
})
export class AccountRemovedDialogComponent {
  constructor(private dialogRef: MatDialogRef<AccountRemovedDialogComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
